import { useContext, useEffect, useRef, useState } from "react";

import Header from "./components/Header";
import PersonalInfo from "./components/AccountCreated";
import Nav from "./components/Nav";
import Welcome from "./components/welcome/Welcome";
import ProfilePhoto from "./components/ProfilePhoto";
import { Context } from "./Provider";
import PersonalInformation from "./components/PersonalInformation";
import SkillSet from "./components/SkillSet";
import UploadedCertificates from "./components/UploadedCertificates";
import UploadedDocuments from "./components/UploadedDocuments";
import Completed from "./components/completed/Completed";
import TermsAndConditions from "./components/termsAndConditions/TermsAndConditions";
import CreateNewAccountButton from "./components/createNewAccount/CreateNewAccountButton";
import DocumentsInHand from "./components/documentsInHand/documentsInHand";
import CopyUrlBox from "./components/welcome/components/CopyUrlBox";

const Html = () => {
    const { state } = useContext(Context);
    const { ftm, step, isCompletedRegistration } = state;

    const [showCompleted, setShowCompleted] = useState(isCompletedRegistration);
    const [showDocumentsInHand, setShowDocumentsInHand] = useState(step?.stepId === 0 ? true : false);

    const profilePhotoRef = useRef(null);
    const personalInfoRef = useRef(null);
    const skillSetRef = useRef(null);
    const uploadedCertificatesRef = useRef(null);
    const uploadedDocumentsRef = useRef(null);

    useEffect(() => {
        if (!step?.stepId) return;

        let targetRef = null;

        switch (step.stepId) {
            case 3:
                targetRef = profilePhotoRef;
                break;
            case 4:
                targetRef = personalInfoRef;
                break;
            case 5:
                targetRef = skillSetRef;
                break;
            case 6:
                targetRef = uploadedCertificatesRef;
                break;
            case 7:
                targetRef = uploadedDocumentsRef;
                break;
            default:
                targetRef = null;
        }

        if (targetRef?.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

    }, [step?.stepId]);

    const handleShowCompleted = () => setShowCompleted(true);
    const handleHideCompleted = () => setShowCompleted(false);

    return (
        <>
            <div className="container">
                <div className="row mt-lg-n12 mt-md-n12 mt-n11 justify-content-center">
                    <div className="container-fluid my-3 py-3 mt-8">
                        <div className="row mb-5">
                            <div className="mt-6 d-block d-md-none">
                                <CreateNewAccountButton />
                            </div>
                            {ftm?.ftm_is_verify !== 1 && (
                                <div className="col-lg-3">
                                    <Nav />
                                </div>
                            )}

                            <div className={`col-lg-${ftm?.ftm_is_verify === 1 ? '12' : '9'} mt-lg-0 mt-4`}>
                                <Header isApproved={ftm?.ftm_is_verify === 1} />
                                <PersonalInfo />
                                {step?.stepId >= 3 && <div ref={profilePhotoRef}><ProfilePhoto /></div>}
                                {step?.stepId >= 4 && <div ref={personalInfoRef}><PersonalInformation /></div>}
                                {step?.stepId >= 5 && <div ref={skillSetRef}><SkillSet /></div>}
                                {step?.stepId >= 6 && <div ref={uploadedCertificatesRef}><UploadedCertificates /></div>}
                                {step?.stepId >= 7 && <div ref={uploadedDocumentsRef}><UploadedDocuments /></div>}

                                {step?.stepId >= 3 && (
                                    <div className="mt-3 d-none d-md-block">
                                        <CopyUrlBox url={window.location.href} name={<>Registration Link</>} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {ftm?.ftm_is_verify !== 1 && (
                <>
                    <Welcome />
                    {step?.stepId === 8 && ftm?.ftm_is_approved_terms_and_conditions !== 1 && <TermsAndConditions handleShowCompleted={handleShowCompleted} />}
                    {showCompleted && <Completed handleHideCompleted={handleHideCompleted} />}
                    {showDocumentsInHand && <DocumentsInHand setShowDocumentsInHand={setShowDocumentsInHand} />}
                </>
            )}
        </>
    );
}

export default Html;